<template>
  <router-view/>
</template>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
  #app {
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    padding: 30px 31px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    min-height: calc(100vh - 60px);
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  #nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }

  :root {
    --color-primary: #253568;
    --color-danger: #DE360B;
    --color-secondary: #861350;
    --color-secondary-light: #EEDEE6;
    --color-text: #454F5B;
  }
  .home {
    width: 100%;
    max-width: 585px;
  }
  h1 {
    font-family: 'Raleway', sans-serif;
    color: var(--color-primary);
    margin: unset;
    font-weight: 700;
    font-size: 30px;
    letter-spacing: 0.67px;
    line-height: 32px;
    text-align: left;
  }
  p {
    color: var(--color-text);
    margin: unset;
    margin-top: 30px;
    font-weight: 400;
    font-size: 17px;
    letter-spacing: 0.4px;
    line-height: 25px;
    text-align: left;
  }
  .submit-button {
    margin-top: 60px;

    display: flex;
    justify-content: space-between;
    align-items: center;
    
    font-family: 'Raleway', sans-serif;
    font-weight: 700;
    font-size: 17px;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: #FFFFFF;
    text-align: center;
    
    background-color: var(--color-primary);
    border-radius: 5px;
    width: 100%;
    border: unset;
    padding: 20px 20px;

    img {
      filter: invert(1);
    }
  }
  .stepReminder {
    font-family: 'Raleway', sans-serif;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.27px;
    text-transform: uppercase;
    color: var(--color-primary);
    text-align: left;
    margin-top: 30px;
  }
  .inputFrame {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 60px;
    width: 100%;
    label {
      font-weight: 400;
      font-size: 17px;
      letter-spacing: 0.4px;
      color: var(--color-text);
      text-align: left;
    }
  }
  .submit-button-back {
    margin-top: 40px;
    
    font-weight: 400;
    font-size: 17px;
    letter-spacing: 0.4px;
    color: var(--color-primary);
    text-align: center;
    
    background-color: transparent;
    border-radius: 5px;
    width: 100%;
    border: unset;

    img {
      padding-right: 15px;
      height: 13px;
      width: 13px;
    }
  }
  .incomeFrame {
    display: flex;
    align-items: center;
    width: calc(100% + 10.68px);
    margin-top: 10px;
    input {
      border: solid 1px #9FA7A7;
      border-radius: 3px;
      padding: 11px 33px 11px 13px;
      width: calc(100% - 48px);
      font-weight: 400;
      font-size: 17px;
      color: #000000;
      text-align: left;
    }
    span {
      pointer-events: none;
      font-weight: 400;
      font-size: 17px;
      letter-spacing: 0.4px;
      color: var(--color-text);
      text-align: left;
      transform: translateX(-22px);
      background-color: #FFFFFF;
    }
  }
  .inputFocus:focus {
    outline: #6179C7 solid 2px;
    border-radius: 3px;
    border-color: transparent;
    box-shadow: 0 0 8px 0 #A1AFDE;
  }
  .inputError {
    outline: var(--color-danger) solid 2px;
    border-radius: 3px;
    border-color: transparent;
    box-shadow: 0 0 8px 0 #DE360B;
    &:focus {
      outline: var(--color-danger) solid 2px;
      border-radius: 3px;
      border-color: transparent;
      box-shadow: 0 0 8px 0 #DE360B;
    }
  }
  .insivibleSpacer {
    width: 13px;
  }
  @media screen and (min-width: 585px) {
    .home {
      display: flex;
      flex-direction: column;
    }
    h1 {
      font-size: 50px;
      letter-spacing: 1.11;
      margin-bottom: 20px;
      margin-top: 0;
      line-height: 55px;
    }
    .submit-button {
      width: 361px;
      padding: 20px 40px;
      cursor: pointer;
    }
    .submit-button-back {
      width: fit-content;
      padding: 0 40px 20px 0;
      cursor: pointer;
    }
    .inputFrame {
      input {
        width: 190px;
      }
    }
    .stepReminder {
      margin-top: 45px;
    }
  }
</style>
